<div class="w-full bg-white">
    <div class="chart-wrapper">
        <canvas baseChart
            [data]="lineChartData"
            [options]="lineChartOptions"
            [type]="lineChartType"
            [legend]="true"
        >
        </canvas>
    </div>
</div>